"use client";

import {
  Alert,
  AlertTitle,
  Backdrop,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import CustomAccordion from "./Ui/CustomAccordion";
import Face6Icon from "@mui/icons-material/Face6";
import VideoFileIcon from "@mui/icons-material/VideoFile";
import ListIcon from "@mui/icons-material/List";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import HandshakeIcon from "@mui/icons-material/Handshake";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import { useState } from "react";
import axios from "axios";
import { requestID, baseUrl, config } from "../common/utils";
import { useBusinessContext } from "../context/business-context";
// import CustomAccordion from "./custom-accordion";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onGetactivationList?: () => void;
  branches: any[];
  roles: any[];
};

export default function GenerateCodeModal({
  isOpen,
  onClose,
  branches,
  roles,
  onGetactivationList
  
}: Props) {
  const [email, setEmail] = useState("");
  const [branch, setBranch] = useState("");
  const [role, setRole] = useState("");
  const [status, setStatus] = useState({ loading: false, error: false });
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");

  const { selectedBusinessId } = useBusinessContext();

  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };

  const onGenerateCode = async () => {
    try {
      setStatus({ loading: true, error: false });
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusinessId);
      formData.append("branch_id", branch);
      formData.append("email", email);
      formData.append("roleID", role);

      const response = await axios.post(
        baseUrl() + "businesss/generateInviteCode",
        formData,
        config
      );
      console.log(response);
      const data = await response.data;

      onClose();
      setEmail("");
      setBranch("");
      setRole("");
      setAlertMsg(data.message || "Code generated successfully.");
      onShowAlert();
      onGetactivationList()
      setStatus({ loading: false, error: false });
    //   onGetactivationList()
    } catch (error) {
      setStatus({ loading: false, error: true });
      console.log(error);
      setAlertMsg(error.response.data.message || "An error occurred.");
      onShowAlert();
    } finally {
      setStatus({ loading: false, error: false });
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxHeight: 600,
          width: 900,
          bgcolor: "white",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
        }}
      >
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          Generate Code
        </Typography>

        {showAlert && (
          <Alert severity={status.error ? "error" : "success"}>
            <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
            {alertMsg?.toUpperCase()}
          </Alert>
        )}

        {/* Email Input */}
        <TextField
          fullWidth
          label="Enter Staff Email"
          type="email"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ my: 2 }}
        />

        {/* Branch Select */}
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Branch</InputLabel>
          <Select
            value={branch}
            label="Branch"
            onChange={(e) => setBranch(e.target.value)}
          >
            {branches?.map((branchOption, index) => (
              <MenuItem key={index} value={branchOption.branch_id}>
                {branchOption.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Role</InputLabel>
          <Select
            value={role}
            label="Select Role"
            onChange={(e) => setRole(e.target.value)}
          >
            {roles?.map((role, index) => (
              <MenuItem key={index} value={role.roleID}>
                {role.name.toUpperCase()}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Submit Button */}
        <Button
          variant="contained"
          sx={{ mt: 4 }}
          onClick={onGenerateCode}
          disabled={!email || !branch}
        >
          {status.loading ? "Loading..." : "Submit"}
        </Button>

        {/* Close Button */}
        <Button variant="outlined" sx={{ mt: 4, ml: 2 }} onClick={onClose}>
          Close
        </Button>
      </Box>
    </Modal>
  );
}
